export default __webpack_public_path__ + "static/media/nus_logo.bfccd39f.png";